export default defineNuxtRouteMiddleware(async (to, from) => {
  let splittedUrl = to.path.split('/');

  // Redireciona para o whatsapp.
  if (splittedUrl.includes('whatsapp')) {
    return navigateTo('https://wa.me/554187379897', { redirectCode: 301, external: true })
  }
})
